import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface LinkedSitesListGridNameCellRendererParams extends ICellRendererParams {
    getName: (params: LinkedSitesListGridNameCellRendererParams) => string;
    getLink: (params: LinkedSitesListGridNameCellRendererParams) => string;
    isMaster: (params: LinkedSitesListGridNameCellRendererParams) => boolean;
    canNavigate: boolean;
}

@Component({
    selector: 'linked-sites-list-grid-name-cell',
    template: `
    @if (params.isMaster(params)) {
      <span
        class="icon-master"
        helpTooltip
        helpContentId="linked-sites.master-site"
        position="bottom">
        <i class="fa fa-star"></i>
      </span>
    }
    @if (!params.canNavigate) {
      <span>
        {{ params.getName(params) }}
      </span>
    }
    @if (params.canNavigate) {
      <a
        class="grid-link-cell"
        [href]="params.getLink(params)"
        target="_blank"
        rel="noopener noreferrer"
        helpTooltip
        helpContentId="app.view-site"
        position="bottom">
        {{ params.getName(params) }}
      </a>
    }
    `,
    standalone: false
})
export class LinkedSitesListGridNameCellRendererComponent implements ICellRendererAngularComp {
    params: LinkedSitesListGridNameCellRendererParams;

    agInit(params: LinkedSitesListGridNameCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
